import React from 'react';
import { Link } from 'react-router-dom';

const NewsItem = props => (
    <li>
        <div>
            <div>{props.item}</div>
            <div><Link to={props.to}>{props.name}</Link></div>
        </div>
    </li>
);

export default NewsItem;